import { z } from 'zod';

// Screen one of sign-up (who you are, how to reach you) lives here until screen two creates
// the account, so a refresh or a trip back to edit does not lose it.
const KEY = 'candidate-web.signup-draft';

const draftSchema = z.object({
  firstName: z.string().min(1),
  lastName: z.string().min(1),
  phone: z.string().min(1),
  email: z.string().min(1),
});

export type SignUpDraft = z.infer<typeof draftSchema>;

export function readDraft(): SignUpDraft | undefined {
  const raw = window.sessionStorage.getItem(KEY);
  if (!raw) return undefined;
  try {
    const parsed = draftSchema.safeParse(JSON.parse(raw));
    return parsed.success ? parsed.data : undefined;
  } catch {
    return undefined;
  }
}

export function writeDraft(draft: SignUpDraft): void {
  window.sessionStorage.setItem(KEY, JSON.stringify(draft));
}

export function clearDraft(): void {
  window.sessionStorage.removeItem(KEY);
}
